import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconHighlightOff = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconHighlightOff",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "m480-424 116 116q11 11 28 11t28-11 11-28-11-28L536-480l116-116q11-11 11-28t-11-28-28-11-28 11L480-536 364-652q-11-11-28-11t-28 11-11 28 11 28l116 116-116 116q-11 11-11 28t11 28 28 11 28-11zm0 344q-83 0-156-31t-127-86-85-127-32-156 32-156 85-127 127-85 156-32 156 32 127 85 86 127 31 156-31 156-86 127-127 86-156 31m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m0-320"
  })
}));